import { useQuery } from "@tanstack/react-query";
import { getSummary, getSensitivitySummary } from "../../api/dashboard";

export const DASHBOARD_QUERY_KEY = ["dashboard"] as const;

export function useDashboardSummary(
  entityId: number,
  entityType: string,
  scenarioId?: number,
  computeGeneration?: number,
  // False until the dashboard is computed: the API has no summary yet and answers 404.
  enabled: boolean = true,
) {
  return useQuery({
    queryKey: [...DASHBOARD_QUERY_KEY, entityType, entityId, computeGeneration],
    queryFn: () =>
      entityType === "sensitivity" && scenarioId
        ? getSensitivitySummary(scenarioId, entityId)
        : getSummary(entityId),
    enabled: enabled && entityId > 0,
    staleTime: 0,
    select: (data) => data.inferred_datas ?? data,
  });
}
